import React from 'react'
import MainLayout from '../layouts/main-layout'
import SEO from '../components/seo'
import CTA from '../components/cta'
import ContentBlock from '../components/content-block'
import PhotoGallery from '../components/photo-gallery'

const GalleryPage = () => (
  <MainLayout titleText="Rooms and Facilities">
    <SEO title="Rooms and Facilities" />

    <ContentBlock
      paragraphs={[
        'The Chester Lodge provides a comfortable and relaxing atmosphere. We have a spacious dining room where guests can enjoy breakfast between 8:30am and 9am each day. As a licensed premises, guests can enjoy a drink in our bar and lounge which has a TV and comfortable seating.',
        'The Chester Lodge has a range of single, double and family rooms available. All of our rooms are en-suite and heated, with a flat-screen TV and tea and coffee making facilities. Towels and linen are provided, as are complimentary toileteries. Guests can request an iron, ironing board and hairdryer as needed.',
        'Our guests can enjoy free Wi-Fi throughout their stay, and we have plenty of free, private parking available on-site. Check in at the Chester Lodge is between 2pm and 6pm, and check out is between 7:30am and 10am.',
        'New to The Chester Lodge for 2021, we have an on-site beauty room providing hair and beauty services.'
      ]}
    />

    <ContentBlock
      titleText="Gallery"
      grey
      AdditionalComponent={PhotoGallery}
    />

    <CTA
      titleText="A home from home"
      buttonTo="/contact-us"
      buttonText="Book Now"
    />
  </MainLayout>
)

export default GalleryPage
